export default token => (token ? JSON.parse(window.atob(token.split('.')[1])) : null);
